export default "__VITE_ASSET__IefCM3uF__"